import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useProjectCardStyles = makeStyles({
  statusDot: {
    display: "inline-block",
    width: "6px",
    height: "6px",
    borderRadius: designTokens.borderRadius.full,
    flexShrink: 0,
  },

  statusNotScored: {
    border: `1px solid ${designTokens.neutral[300]}`,
  },

  statusNotScoredDot: {
    backgroundColor: designTokens.neutral[600],
  },

  statusInProgressDot: {
    backgroundColor: designTokens.semantic.info,
  },

  statusScoredDot: {
    backgroundColor: designTokens.semantic.success,
  },

  statusErrorDot: {
    backgroundColor: designTokens.semantic.error,
  },
});
